import { Button } from '@cellula/react';
import { ConsentDialog } from './consent_dialog.component';
import { withTranslation } from '@application/i18n/with_translation';

interface Props {}

export function ConsentTrigger(_: Props) {
	return (
		<ConsentDialog
			trigger={
				<Button size='xSmall' variant='secondary'>
					{withTranslation('Component.Consent.Trigger.Button')}
				</Button>
			}
		/>
	);
}
